@if (langList?.length > 1) {
  @for (lang of langList; track lang) {
    <div
      class="list-item">
      <div class="btn btn-light btn-sidebar btn-sidebar-1"
        (click)="langSvc.langSelected(lang)"
        translate>
        <span class="flag flag-icon-background flag-icon {{lang.flag}} mx-2"></span>
        {{lang.name}}
      </div>
    </div>
  }
}
